const angular = require('angular');
const app = angular.module('learn-directives');
const moment = require('moment');
/**
 * Defines the admin user reports component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('userBadges', ['Application', 'Authorization', 'Badges', function(Application, Authorization, Badges) {
    return {
        restrict: 'E',
        scope: {

        },
        template: require('../../templates/directives/user-badges.html'),
        controller: ['$scope', function ($scope) {
            var self = this;
            self.user = Authorization.getAuthToken().user;
            self.badgesEarned = [];
            self.actions = {
                navContent: (id) => {
                    Application.navigation.goTo('/overview/badges/' + id);
                }
            };
            self.init = () => {
                Badges.getAwardedByUser({subsubsubresource: self.user._id.toString()}).$promise.then((results) => {
                  self.badgesEarned = results;
                });
            };
            self.init();
        }],
        controllerAs: 'userBadges'
    };
}]);